import { styled } from "styled-components";
import posts from "../posts.json";
import ShortBlog from "./ShortBlog";

function LatestBlogs() {
  return (
    <LatestWrapper>
      <Content>{posts.slice(1).map((p) => (
        <ShortBlog key={p.id} post={p} />
      ))}</Content>
    </LatestWrapper>
  );
}

export default LatestBlogs;

const LatestWrapper = styled.section`
  padding-top: 10px
`;

export const Content = styled.section`
    display: flex;
    gap: 10px; 
    flex-wrap: wrap;   
    p{
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;  
        overflow: hidden;
    }
    button {
        margin-top: 20px
    }
`;
